import { Card, Label } from "reactstrap";
import { useEffect, useState } from "react";
import AppModal from "../../Common/AppModal";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { getProductList } from "../../../store/products/action";
import { useDispatch, useSelector } from "react-redux";
import Select from "../../Common/AppSelect";
import {
  createJobInvoiceItemTemplate,
  createJobInvoiceItemTemplateSuccess,
  getJobInvoiceItemTemplateList,
  updateJobInvoiceItemTemplate,
  updateJobInvoiceItemTemplateSuccess,
} from "../../../store/invoiceCrmIT/action";
import { isEmpty } from "lodash";
import { toast } from "react-toastify";
// Change #100067 - retired products are not offered when adding a line.
import { isProductActive } from "../../../helpers/functions/productActive";

const CreateUpdateBillableItemsTemplate = ({
  isOpen,
  toggle,
  isEdit,
  templateData,
}) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getProductList());
  }, []);

  const { productListApi } = useSelector((state) => ({
    productListApi: state.Products.productsList?.product_list,
  }));

  const [createUpdateData, setCreateUpdateData] = useState({
    Name: "",
    Description: "",
    jobinvoiceitemtemplateitem_list: [],
  });

  useEffect(() => {
    if (!isEdit) return;
    if (isEmpty(templateData)) return;
    setCreateUpdateData({
      Id: templateData.Id,
      Name: templateData.Name,
      Description: templateData.Description,
      jobinvoiceitemtemplateitem_list:
        templateData.jobinvoiceitemtemplateitem_list?.map((item, index) => ({
          Id: item.Id,
          Lid: index + 1,
          Product_Id: item.Product_Id,
          Order: item.Order,
        })),
    });
  }, [templateData]);

  const handleRemoveProduct = (product) => {
    // check if product Lid is already in the list the remove it
    // else add it
    if (
      createUpdateData.jobinvoiceitemtemplateitem_list.find(
        (item) => item.Lid === product.Lid
      )
    ) {
      setCreateUpdateData({
        ...createUpdateData,
        jobinvoiceitemtemplateitem_list:
          createUpdateData.jobinvoiceitemtemplateitem_list.filter(
            (item) => item.Lid !== product.Lid
          ),
      });
    }
  };
  const [currentlySelectedProduct, setCurrentlySelectedProduct] =
    useState(null);
  console.log("currentlySelectedProduct", currentlySelectedProduct);

  const handleCreateUpdateTemplate = () => {
    if (isEdit) {
      // update
      dispatch(updateJobInvoiceItemTemplate([createUpdateData]));
    } else {
      // create
      dispatch(createJobInvoiceItemTemplate([createUpdateData]));
    }
  };
  const [loading, setLoading] = useState(false);
  const {
    createInvoiceItemTemplateAPI,
    updateInvoiceItemTemplateAPI,
    createInvoiceItemTemplateLoading,
    updateInvoiceItemTemplateLoading,
  } = useSelector((state) => ({
    createInvoiceItemTemplateAPI: state.InvoiceCrmIT.createInvoiceItemTemplate,
    updateInvoiceItemTemplateAPI: state.InvoiceCrmIT.updateInvoiceItemTemplate,
    createInvoiceItemTemplateLoading:
      state.InvoiceCrmIT.createInvoiceItemTemplateLoading,
    updateInvoiceItemTemplateLoading:
      state.InvoiceCrmIT.updateInvoiceItemTemplateLoading,
  }));

  const helperUpdateData = () => {
    dispatch(getJobInvoiceItemTemplateList());
  };

  //create
  useEffect(() => {
    if (isEmpty(createInvoiceItemTemplateAPI)) return;
    if (createInvoiceItemTemplateAPI.status === 200) {
      toast.success(createInvoiceItemTemplateAPI.message);
      helperUpdateData();
      toggle();
    } else {
      toast.error(createInvoiceItemTemplateAPI.message);
    }
    dispatch(createJobInvoiceItemTemplateSuccess([]));
  }, [createInvoiceItemTemplateAPI]);
  //update
  useEffect(() => {
    if (isEmpty(updateInvoiceItemTemplateAPI)) return;
    if (updateInvoiceItemTemplateAPI.status === 200) {
      toast.success(updateInvoiceItemTemplateAPI.message);
      helperUpdateData();
      toggle();
    } else {
      toast.error(updateInvoiceItemTemplateAPI.message);
    }
    dispatch(updateJobInvoiceItemTemplateSuccess([]));
  }, [updateInvoiceItemTemplateAPI]);

  return (
    <AppModal
      open={isOpen}
      onClose={toggle}
      title={isEdit ? "Update Template" : "Create New Template"}
      icon={<DescriptionOutlinedIcon />}
      headerAccent="indigo"
      size="sm"
      onSubmit={() => handleCreateUpdateTemplate()}
      submitLabel={isEdit ? "Update" : "Create"}
      submitColor="success"
      cancelLabel="Close"
    >
        <div className={"pt-2"}>
          <Label>Template Name</Label>
          <input
            type={"text"}
            className={"form-control"}
            value={createUpdateData.Name}
            onChange={(e) =>
              setCreateUpdateData({ ...createUpdateData, Name: e.target.value })
            }
          />
        </div>
        <div className={"pt-2"}>
          <Label>Description</Label>
          <input
            type="text"
            className={"form-control"}
            value={createUpdateData.Description}
            onChange={(e) =>
              setCreateUpdateData({
                ...createUpdateData,
                Description: e.target.value,
              })
            }
          />
        </div>
        <div>
          <Label>Add New product to your template List</Label>
          <div className={"d-flex w-100"}>
            <Select
              className={"w-100"}
              options={productListApi?.filter(isProductActive).map((product) => ({
                value: product.Id,
                label: product.Name,
                LProduct: product,
              }))}
              onChange={(selected) => {
                setCurrentlySelectedProduct(selected.LProduct);
              }}
            ></Select>
            <button
              className={"ms-2 btn btn-success"}
              onClick={() => {
                const Lid =
                  createUpdateData.jobinvoiceitemtemplateitem_list.length > 0
                    ? Math.max(
                        ...createUpdateData.jobinvoiceitemtemplateitem_list.map(
                          (item) => item.Lid
                        )
                      ) + 1
                    : 1;
                setCreateUpdateData({
                  ...createUpdateData,
                  jobinvoiceitemtemplateitem_list: [
                    ...createUpdateData.jobinvoiceitemtemplateitem_list,
                    {
                      Lid,
                      Product_Id: currentlySelectedProduct.Id,
                      Order: currentlySelectedProduct.Order,
                    },
                  ],
                });
              }}
            >
              Add
            </button>
          </div>
        </div>
        <div className={"pt-2"}>
          <Label>Products List</Label>
          <div className={"d-flex flex-column"}>
            {createUpdateData.jobinvoiceitemtemplateitem_list.map((product) => (
              <div key={product.Lid} className={"w-100"}>
                <Card className={"p-2"}>
                  <div className={"d-flex justify-content-between"}>
                    <div>
                      <div>#{product.Product_Id}</div>
                      <div>
                        {
                          productListApi?.find(
                            (item) => item.Id === product.Product_Id
                          )?.Name
                        }
                      </div>
                      <div>
                        {
                          productListApi?.find(
                            (item) => item.Id === product.Product_Id
                          )?.Description
                        }
                      </div>
                    </div>

                    <div className={"d-flex justify-content-end"}>
                      <div>
                        <button
                          title={"Remove Product"}
                          className={"btn btn-sm btn-danger"}
                          onClick={() => handleRemoveProduct(product)}
                        >
                          <i className="fa-solid fa-trash"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </Card>
              </div>
            ))}
          </div>
        </div>
    </AppModal>
  );
};

export default CreateUpdateBillableItemsTemplate;
